import React from "react";

export default function LeaveTableHeader({ sortConfig, handleSort }) {
  return (
   
      <thead>
        <tr>
          <th
            colSpan={2}
            onClick={() => handleSort("employee_full_name")}
            style={{ cursor: "pointer" }}
          >
            Employee Details{" "}
            {sortConfig.key === "employee_full_name" &&
              (sortConfig.direction === "asc" ? "↑" : "↓")}
          </th>
          <th
            onClick={() => handleSort("apply_date")}
            style={{ cursor: "pointer" }}
          >
            Applied Date{" "}
            {sortConfig.key === "apply_date" &&
              (sortConfig.direction === "asc" ? "↑" : "↓")}
          </th>
          <th
            onClick={() => handleSort("leave_from")}
            style={{ cursor: "pointer" }}
          >
            Start Date{" "}
            {sortConfig.key === "leave_from" &&
              (sortConfig.direction === "asc" ? "↑" : "↓")}
          </th>
          <th>End Date</th>
          <th>Days</th>
          <th
            onClick={() => handleSort("leave_type")}
            style={{ cursor: "pointer" }}
          >
            Type{" "}
            {sortConfig.key === "leave_type" &&
              (sortConfig.direction === "asc" ? "↑" : "↓")}
          </th>
          <th
            onClick={() => handleSort("status")}
            style={{ cursor: "pointer" }}
          >
            Status{" "}
            {sortConfig.key === "status" &&
              (sortConfig.direction === "asc" ? "↑" : "↓")}
          </th>
          <th>Actions</th>
          <th>More</th>
        </tr>
      </thead>
    
  );
}
